import { mergeAttributes } from '@tiptap/core';
import { DOMOutputSpec } from '@tiptap/pm/model';

export default {
  renderText({ node }: { node: any }): string {
    return `${node.attrs.name} (${node.attrs['data-url']})`;
  },
  renderHTML({ node, HTMLAttributes }: { node: any; HTMLAttributes: any }): DOMOutputSpec {
    return [
      'a',
      mergeAttributes({ 'data-type': 'internal-link' }, HTMLAttributes, {
        href: node.attrs['data-url'],
      }),
      node.attrs.name,
    ];
  },
};
